module.exports = __webpack_public_path__ + "img/conversation_icon.274165ea.svg";